/**
 * Helpers for Health Check Diagnostic capture HTML/HAR artifacts.
 * Artifacts are optional fields on the capture JSON snapshot (older builds omit them).
 */

function pick(json, camelKey, pascalKey) {
  if (!json || typeof json !== 'object') {
    return undefined
  }
  if (json[camelKey] !== undefined) {
    return json[camelKey]
  }
  return json[pascalKey]
}

export function getCapturePageHtml(capture) {
  const raw = pick(capture?.json, 'pageHtml', 'PageHtml')
  if (raw == null) {
    return null
  }
  const text = String(raw)
  return text.length > 0 ? text : null
}

export function getCaptureHar(capture) {
  const har = pick(capture?.json, 'har', 'Har')
  if (!har || typeof har !== 'object') {
    return null
  }
  return har
}

export function isPageHtmlTruncated(capture) {
  return Boolean(pick(capture?.json, 'pageHtmlTruncated', 'PageHtmlTruncated'))
}

export function isHarTruncated(capture) {
  return Boolean(pick(capture?.json, 'harTruncated', 'HarTruncated'))
}

export function buildDiagnosticArtifactFilename(eventCode, captureId, extension) {
  const safeCode = (eventCode || 'capture')
    .toString()
    .replace(/[^a-zA-Z0-9._-]+/g, '_')
    .slice(0, 64)
  const idPart =
    captureId != null && String(captureId).trim() !== ''
      ? String(captureId)
      : 'unknown'
  return `${safeCode}-${idPart}.${extension}`
}

/**
 * Triggers a browser download from an in-memory string. Safe no-op when document is missing.
 */
export function downloadTextFile(filename, content, mimeType) {
  if (typeof document === 'undefined' || content == null) {
    return false
  }
  const blob = new Blob([content], { type: mimeType || 'text/plain;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.rel = 'noopener'
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
  return true
}

/** Always use empty sandbox (no scripts / same-origin) for Hilton HTML previews. */
export const DIAGNOSTIC_HTML_IFRAME_SANDBOX = ''
